// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1e849ba2","453":"bb828c5d"}[chunkId] + ".chunk.js";
};